import { render } from "./LicenseAndPolicies.vue?vue&type=template&id=d1c043f8&scoped=true"
import script from "./LicenseAndPolicies.vue?vue&type=script&lang=js"
export * from "./LicenseAndPolicies.vue?vue&type=script&lang=js"

import "./LicenseAndPolicies.vue?vue&type=style&index=0&id=d1c043f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c043f8"]])

export default __exports__